import React from 'react'
import { Switch } from 'react-router-dom'

const TabPanelContainer = ({ children }) => {
  return <Switch>{children}</Switch>
}

export default TabPanelContainer
